export default __webpack_public_path__ + "static/bv-5085fbffe49cb6918ccb9746cefd9a28.jpg";